/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateScriptSectionRequest
 */
export interface CreateScriptSectionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateScriptSectionRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScriptSectionRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateScriptSectionRequest
     */
    order?: number;
}

/**
 * Check if a given object implements the CreateScriptSectionRequest interface.
 */
export function instanceOfCreateScriptSectionRequest(value: object): boolean {
    return true;
}

export function CreateScriptSectionRequestFromJSON(json: any): CreateScriptSectionRequest {
    return CreateScriptSectionRequestFromJSONTyped(json, false);
}

export function CreateScriptSectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateScriptSectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function CreateScriptSectionRequestToJSON(value?: CreateScriptSectionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'order': value['order'],
    };
}

